import { FiEye } from "react-icons/fi";

const MessageStatus = ({ message, isFromCurrentUser }) => {
    if (!isFromCurrentUser) return null;

    // ✅ Use white for all outgoing ticks to ensure visibility on primary/media bubbles
    const seenColor = "#FFFFFF";

    // not seen yet
    if (!message.seen) {
        return (
            <span className="text-white/60 text-xs ml-1">
                ✓
            </span>
        );
    }

    // ✅ Seen → Double White Ticks
    return (
        <span className="ml-1">
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M1 13L5 17L13 9"
                    stroke={seenColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13L12 17L23 6"
                    stroke={seenColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};


const GroupMessageStatus = ({
    message,
    isFromCurrentUser,
    totalMembers,
    onViewDetails
}) => {

    if (!isFromCurrentUser) return null;

    // Handle both seenBy (group) and isSeen (community)
    const viewers = message.seenBy || message.isSeen || {};
    // Exclude self from the count
    const seenCount = Object.keys(viewers).filter(uid => uid !== message.senderId).length;

    const allSeen = seenCount >= (totalMembers || 1) - 1;
    // minus sender

    // ✅ Use white for all outgoing ticks/indicators
    const seenColor = "#FFFFFF";
    const viewCountColor = "text-white/80";

    if (!allSeen) {
        return (
            <div className="flex items-center gap-1 ml-1">
                <button 
                    className={`${viewCountColor} text-[11px] hover:underline flex items-center gap-0.5 transition-opacity`}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (onViewDetails) onViewDetails(message);
                    }}
                >
                    <FiEye size={12} className="opacity-90" />
                    <span>{seenCount}</span>
                </button>
                <span className="text-white/60 text-xs">
                    ✓
                </span>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-1 ml-1">
            <button 
                className={`${viewCountColor} text-[11px] hover:underline flex items-center gap-0.5 transition-opacity`}
                onClick={(e) => {
                    e.stopPropagation();
                    if (onViewDetails) onViewDetails(message);
                }}
            >
                <FiEye size={12} className="opacity-90" />
                <span>{seenCount}</span>
            </button>
            <span>
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M1 13L5 17L13 9"
                        stroke={seenColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8 13L12 17L23 6"
                        stroke={seenColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </div>
    );
};

export { MessageStatus, GroupMessageStatus };